var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.hasSelection && _vm.hasFrontendTotals
    ? _c("div", { staticClass: "selection-totals-wrapper" }, [
        _c(
          "div",
          { staticClass: "totals" },
          [
            _vm._l(_vm.selectionTotals, function (total, i) {
              return [
                !total.Hidden
                  ? _c(
                      "div",
                      {
                        key: i,
                        staticClass: "total selection-total",
                        style: total.getStyle(),
                      },
                      [_c("div", [_vm._v(" " + _vm._s(total.Text) + " ")])]
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }